import {
    Divider,
    HStack,
    Skeleton,
    SkeletonCircle,
    Stack,
} from '@chakra-ui/react';

export default function SSOLoadingSkeleton({ darkMode }) {
    return (
        <Stack>
            <Stack mb={3}>
                <HStack width="8%">
                    <SkeletonCircle flex={1} size={5} />
                    <Skeleton flex={3} h={5} />
                </HStack>
                <Skeleton h={5} width="10%" />
            </Stack>
            <Stack mb={3}>
                <HStack width="8%">
                    <SkeletonCircle flex={1} size={5} />
                    <Skeleton flex={3} h={5} />
                </HStack>
                <Skeleton width="26%" h={5} />
            </Stack>
            <HStack width="12%">
                <Skeleton flex={1} border="10px" h={6} />
                <Skeleton flex={1} border="10px" h={8} />
            </HStack>
            <Divider h={1} borderColor={darkMode ? 'gray.600' : 'gray.200'} />
            <HStack>
                <Skeleton border="10px" flex={1} h={5} />
                <Skeleton border="10px" flex={1} h={5} />
                <Skeleton border="10px" flex={1} h={5} />
                <Skeleton border="10px" flex={1} h={5} />
            </HStack>
            <HStack>
                <Skeleton border="10px" flex={1} h={8} />
                <Skeleton border="10px" flex={1} h={8} />
                <Skeleton border="10px" flex={1} h={8} />
                <Skeleton border="10px" flex={1} h={8} />
            </HStack>
            <Divider h={1} borderColor={darkMode ? 'gray.600' : 'gray.200'} />
        </Stack>
    );
}
